import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../index";
import apiSvc from "../../services/api";

import {
    SessionDataObject,
    SessionOptions,
    SingleSessionOptions,
    MasterSessionObject
} from "@/types/interfaces";

@Module({
    dynamic: true,
    store: Store,
    name: "getSessionData",
    namespaced: true
})
export default class GetSessionsModule extends VuexModule {
    sessionData: MasterSessionObject = {
        onDemand: [],
        upcomingSessions: [],
        currentTimeISO: ""
    };

    singleSession: SessionDataObject = {
        isSponsorVideo: false,
        image: "",
        videoUrl: "",
        videoUrlOnDemand: "",
        insightId: "",
        date: "",
        description: "",
        startTime: "",
        endTime: "",
        speakers: [
            {
                biography: "",
                title: "",
                name: ""
            }
        ],
        title: "",
        currentTimeISO: "",
        startTimeISO: "",
        endTimeISO: "",
        onDemandOnly: false,
        notForOnDemand: false,
        speakeasyType: "",
        document: "",
        notForPromo: false
    };

    get sessionOptions() {
        const options = this.context.rootState?.themeConfig?.sessionOptions;
        return options || {};
    }

    get session() {
        return this.singleSession;
    }

    get sessionEarlyAccessMinutes() {
        const earlyMinutesOption = parseInt(
            this.sessionOptions?.earlyAccessMinutes
        );
        let returnValue = 15;

        if (-1 < earlyMinutesOption) {
            returnValue = earlyMinutesOption;
        }

        return returnValue;
    }

    get sessionOnDemand() {
        if (this.sessionData) {
            return this.sessionData.onDemand
                .map(session => {
                    return { ...session, isExpanded: false };
                })
                .filter(item => {
                    return Boolean(!item.notForOnDemand);
                });
        } else {
            return [];
        }
    }

    get sessionPromos() {
        if (this.sessionData) {
            return this.sessionData.onDemand
                .map(session => {
                    return { ...session, isExpanded: false };
                })
                .filter(item => {
                    return Boolean(!item.notForPromo);
                });
        } else {
            return [];
        }
    }

    @Mutation
    public setSessions(data: MasterSessionObject) {
        this.sessionData = data;
    }

    @Mutation setSingleSession(data: SessionDataObject) {
        this.singleSession = data;
    }

    @Action({ commit: "setSessions" })
    getSessionData(options: SessionOptions) {
        const tableName = options.isDemoData
            ? "demo-sessions"
            : options.tableName;

        return new Promise((resolve, reject) => {
            apiSvc
                .getSessions(tableName)
                .then((response: any) => {
                    return resolve(response.data);
                })
                .catch((error: any) => {
                    return reject(error);
                });
        });
    }

    @Action({ commit: "setSingleSession" })
    getSingleSession(options: SingleSessionOptions) {
        const tableName = options.isDemoData
            ? "demo-sessions"
            : options.tableName;

        return new Promise((resolve, reject) => {
            apiSvc
                .getSession(options.sessionId, tableName)
                .then((response: any) => {
                    return resolve(response.data);
                })
                .catch(error => {
                    return reject(error);
                });
        });
    }
}
